import reportSetting from '@/entities/insights/modal/report-setting/report-setting.vue';
import { CmGroupItem } from '@/shared/model/cm-group-item.model';
import { detectFile, isNullish } from '@/util/ds-util';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { Component, Inject, Vue, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import BriefingService from '@/service/briefing.service';
import moment from 'moment';
import type { BriefingResourceItem, IBriefingPage } from '@/shared/model/briefing-widget.model';
import { Subscription } from 'rxjs';
import WebsocketService from '@/service/websocket.service';
import { formatDateAgo } from '../../../util/date-util';
import { nextTick } from '@vue/composition-api';
import ref from 'vue';
import { map2ResourceItem } from '@/util/mapper-utils';

const groupsManagerStore = namespace('groupsManagerStore');
const briefingStore = namespace('briefingStore');
const appStoreState = namespace('appStore');
@Component({
  computed: {
    moment() {
      return moment;
    },
  },
  components: {
    vueCustomScrollbar: vueCustomScrollbar,
    'report-setting': reportSetting,
  },
  methods: {
    formatDateAgo,
    isNullish,
    detectFile,
  },
})
export default class MyReportSidebar extends Vue {
  @Prop(Array) readonly briefingPages: IBriefingPage[];
  @Prop(Array) readonly briefingPageIds: IBriefingPage[];
  @Prop(Boolean) readonly isClearAll: boolean | false;
  @Prop(Object) readonly clearItemInBriefingPagesFilter: IBriefingPage | null;

  countCard = 0;
  briefingPagesFilterSidebar: IBriefingPage[] = [];
  briefingPageIdsSidebar: any[] = [];
  userKey = JSON.parse(localStorage.getItem('localStorageUser')).id;
  isViewAllReport = true;

  scrollSettings = {
    wheelPropagation: false,
  };

  @Watch('isClearAll')
  onClearAllFromListChange() {
    if (this.isClearAll == true) {
      this.resetAll();
      this.$emit('isClearAllFilter', false);
    }
  }

  @Watch('briefingPageIds')
  onBriefingPagesIdsChange() {
    this.briefingPageIdsSidebar = this.briefingPageIds;
  }

  @Watch('clearItemInBriefingPagesFilter')
  async onClearItemInBriefingPagesFilterChange() {
    if (this.briefingPagesFilterSidebar.includes(this.clearItemInBriefingPagesFilter)) {
      await this.briefingFilter(this.clearItemInBriefingPagesFilter);
      this.$emit('clearItemInBriefingPagesFilter', {});
    }
  }

  onImageError(event) {
    event.target.src = 'content/images/images_v3/common/go-empty-thumb-sz64.png';
  }

  getImageSrc(imageUri, index) {
    const uniqueQuery = Date.now();
    return `${imageUri}?v=${index + Math.random()}`;
  }

  async briefingFilter(item) {
    if (this.briefingPagesFilterSidebar.includes(item)) {
      this.briefingPagesFilterSidebar = this.briefingPagesFilterSidebar.filter(it => it.bpId !== item.bpId);
      this.briefingPageIdsSidebar = this.briefingPageIdsSidebar.filter(bpId => bpId !== item.bpId);
    } else {
      this.briefingPagesFilterSidebar.push(item);
      this.briefingPageIdsSidebar.push(item.bpId);
    }
    if (!this.briefingPagesFilterSidebar || this.briefingPagesFilterSidebar.length == 0) {
      this.$emit('currentPage', 0);
    }
    this.$emit('briefingPagesFilterToParent', this.briefingPagesFilterSidebar);
    this.$emit('briefingPagesIdsToParent', this.briefingPageIdsSidebar);
    return this.briefingPagesFilterSidebar.includes(item);
  }

  async noBriefingFilter(item) {
    //'reportNoBriefing'
    if (this.briefingPageIdsSidebar.includes(item)) {
      this.briefingPageIdsSidebar = this.briefingPageIdsSidebar.filter(bpId => bpId !== item);
    } else {
      this.briefingPageIdsSidebar.push(item);
    }
    if (!this.briefingPageIdsSidebar || this.briefingPageIdsSidebar.length == 0) {
      this.$emit('currentPage', 0);
    }
    this.$emit('briefingPagesIdsToParent', this.briefingPageIdsSidebar);
    return this.briefingPageIdsSidebar.includes(item);
  }

  resetAll() {
    this.briefingPagesFilterSidebar = [];
    this.briefingPageIdsSidebar = [];
    this.$emit('isClearAllFilter', true);
    this.$emit('briefingPagesFilterToParent', []);
    this.$emit('briefingPagesIds', []);
    this.$emit('currentPage', 0);
  }
}
